// Implements: F-IDN-027
/**
 * The cache keys of the organization pages, each carrying the organization's id (checklist 14),
 * and the invalidation every write runs: the page's own lists plus the backoffice and P4 lists that
 * name the same people and teams, so no other screen keeps showing the state before the write.
 */

import type { QueryClient } from "@tanstack/react-query";

import { organizationPeopleKey as sharedPeopleKey } from "../../../shared/api/queryKeys";

export function peopleKey(organizationId: string): readonly string[] {
  return ["organization", organizationId, "people"];
}

/** Under the people key, so every write that re-reads the people re-reads this answer too. */
export function reassignCandidatesKey(organizationId: string, userId: string): readonly string[] {
  return ["organization", organizationId, "people", userId, "reassign-candidates"];
}

export function teamsKey(organizationId: string): readonly string[] {
  return ["organization", organizationId, "teams"];
}

export function invitationsKey(organizationId: string): readonly string[] {
  return ["organization", organizationId, "invitations"];
}

export const ORGANIZATIONS_KEY = ["organization", "platform", "organizations"] as const;

/** Re-read everything that names this organization's people and teams. */
export async function refreshOrganization(queryClient: QueryClient, organizationId: string): Promise<void> {
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: ["organization", organizationId] }),
    queryClient.invalidateQueries({ queryKey: ["backoffice", "organization", organizationId] }),
    queryClient.invalidateQueries({ queryKey: sharedPeopleKey(organizationId) }),
  ]);
}
